import { handleCourseFiltering } from 'src/components/Filter/ExpandedMenu/events'
import { setFilter } from 'src/redux/slices/eLearning/list'

export const handleCheckboxChange = (e, filterBody) => (dispatch) => {
  const payload = handleCourseFiltering(e, filterBody)
  dispatch(setFilter(payload))
}
